import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import './assets/dist/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/rfs.css';
import * as myConstClass from './constant.js';
import Header from './Header.js';
import Footer from './Footer.js';
import $ from 'jquery';

// Translation Higher Order Component
import {
  getLanguage,
  translate,
} from 'react-switch-lang';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';

class SetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Page states: 'loading', 'error', 'form', 'success'
      pageState: 'loading',
      
      // Token from URL
      token: '',
      
      // User info from verification
      verifiedEmail: '',
      userId: null,
      
      // Form data
      password: '',
      confirmPassword: '',
      
      // Error messages
      errorMessage: '',
      passwordError: '',
      confirmPasswordError: '',
      
      // Loading state for form submission
      isSubmitting: false,
    };
    
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // Extract token from URL
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (!token) {
      this.setState({
        pageState: 'error',
        errorMessage: 'Invalid or missing registration link. Please check your email.'
      });
      return;
    }
    
    this.setState({ token }, () => {
      // Verify email automatically
      this.verifyEmail(token);
    });
  }

  async verifyEmail(token) {
    try {
      const response = await fetch(`${myConstClass.GUEST_AUTH_API}/verify-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token })
      });
      
      const data = await response.json();
      
      if (data.status === 'true') {
        // Email verified successfully
        this.setState({
          pageState: 'form',
          verifiedEmail: data.email,
          userId: data.userId
        });
        
        toast('Email verified successfully! Please set your password.', {
          containerId: 'B',
          type: toast.TYPE.SUCCESS
        });
      } else {
        // Verification failed
        let errorMsg = data.message || 'Email verification failed';
        
        // Provide user-friendly messages
        if (errorMsg.includes('expired')) {
          errorMsg = 'This registration link has expired (24 hours). Please place a new order or contact support.';
        } else if (errorMsg.includes('already used')) {
          errorMsg = 'This link has already been used. Please login with your credentials.';
        } else if (errorMsg.includes('Invalid token')) {
          errorMsg = 'Invalid registration link. Please check your email or contact support.';
        }
        
        this.setState({
          pageState: 'error',
          errorMessage: errorMsg
        });
        
        toast(errorMsg, {
          containerId: 'B',
          type: toast.TYPE.ERROR
        });
      }
    } catch (error) {
      console.error('Email verification error:', error);
      this.setState({
        pageState: 'error',
        errorMessage: 'Failed to verify email. Please check your internet connection and try again.'
      });
      
      toast('Network error. Please try again.', {
        containerId: 'B',
        type: toast.TYPE.ERROR
      });
    }
  }

  handlePasswordChange(e) {
    const password = e.target.value;
    this.setState({ password, passwordError: '' });
  }

  handleConfirmPasswordChange(e) {
    const confirmPassword = e.target.value;
    this.setState({ confirmPassword, confirmPasswordError: '' });
  }

  validateForm() {
    const { password, confirmPassword } = this.state;
    let isValid = true;
    
    // Validate password
    if (!password || password.length < 6) {
      this.setState({ passwordError: 'Password must be at least 6 characters long' });
      isValid = false;
    }
    
    // Validate confirm password
    if (!confirmPassword) {
      this.setState({ confirmPasswordError: 'Please confirm your password' });
      isValid = false;
    } else if (password !== confirmPassword) {
      this.setState({ confirmPasswordError: 'Passwords do not match' });
      isValid = false;
    }
    
    return isValid;
  }

  async handleSubmit(e) {
    e.preventDefault();
    
    // Validate form
    if (!this.validateForm()) {
      return;
    }
    
    this.setState({ isSubmitting: true });
    $('#btn_submit').css('display', 'none');
    $('#loader').css('display', 'inline');
    
    try {
      const { verifiedEmail, password, confirmPassword } = this.state;
      
      // Call the new /set-password-guest API
      const response = await fetch(`${myConstClass.PASSWORD_API}/set-password-guest`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: verifiedEmail,
          new_password: password,
          confirm_password: confirmPassword
        })
      });
      
      const data = await response.json();
      
      if (data.status === 'true') {
        // Success - account converted from guest to registered
        this.setState({
          pageState: 'success',
          isSubmitting: false
        });
        
        toast('Account created successfully! You can now login with your email and password.', {
          containerId: 'B',
          type: toast.TYPE.SUCCESS
        });
        
        // Redirect to login after 2 seconds
        setTimeout(() => {
          this.props.history.push('/signin');
        }, 2000);
      } else {
        // Password set failed
        $('#btn_submit').css('display', 'inline');
        $('#loader').css('display', 'none');
        
        let errorMsg = data.message || 'Failed to set password';
        
        // Provide user-friendly messages based on API response
        if (errorMsg.includes('not found')) {
          errorMsg = 'User account not found. Please contact support.';
        } else if (errorMsg.includes('only for guest users')) {
          errorMsg = 'This account is already registered. Please login with your credentials.';
        } else if (errorMsg.includes('inactive')) {
          errorMsg = 'Account is inactive. Please contact support.';
        } else if (errorMsg.includes('do not match')) {
          errorMsg = 'Passwords do not match. Please try again.';
        } else if (errorMsg.includes('at least 6 characters')) {
          errorMsg = 'Password must be at least 6 characters long.';
        }
        
        this.setState({
          isSubmitting: false,
          errorMessage: errorMsg
        });
        
        toast(errorMsg, {
          containerId: 'B',
          type: toast.TYPE.ERROR
        });
      }
    } catch (error) {
      console.error('Set password error:', error);
      $('#btn_submit').css('display', 'inline');
      $('#loader').css('display', 'none');
      
      this.setState({
        isSubmitting: false
      });
      
      toast('Network error. Please check your connection and try again.', {
        containerId: 'B',
        type: toast.TYPE.ERROR
      });
    }
  }

  renderLoading() {
    const { t } = this.props;
    return (
      <div className="container mt-5 mb-5">
        <Row className="justify-content-center">
          <Col lg="6" md="8" sm="10">
            <Card className="shadow-sm">
              <CardBody className="text-center p-5">
                <div className="mb-3">
                  <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
                <h4>{t('home.Verifying your email')}</h4>
                <p className="text-muted">{t('home.Please wait...')}</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  renderError() {
    const { errorMessage } = this.state;
    const { t } = this.props;
    
    return (
      <div className="container mt-5 mb-5">
        <Row className="justify-content-center">
          <Col lg="6" md="8" sm="10">
            <Card className="shadow-sm">
              <CardBody className="text-center p-5">
                <div className="mb-3">
                  <i className="fas fa-exclamation-circle text-danger" style={{ fontSize: '4rem' }}></i>
                </div>
                <h4 className="text-danger">{t('home.Verification Failed')}</h4>
                <p className="mt-3">{errorMessage}</p>
                <div className="mt-4">
                  <Link to="/signin" className="btn btn-brown">
                    {t('home.Go to Login')}
                  </Link>
                  <Link to="/" className="btn btn-outline-secondary ml-2">
                    {t('home.Return to Home')}
                  </Link>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  renderForm() {
    const {
      verifiedEmail,
      password,
      confirmPassword,
      passwordError,
      confirmPasswordError,
      isSubmitting
    } = this.state;
    const { t } = this.props;
    
    return (
      <div className="container mt-5 mb-5">
        <Row className="justify-content-center">
          <Col lg="6" md="8" sm="10">
            <Card className="shadow-sm">
              <CardBody className="p-5">
                <div className="text-center mb-4">
                  <i className="fas fa-check-circle text-success" style={{ fontSize: '3rem' }}></i>
                  <h3 className="mt-3">{t('home.Set Your Password')}</h3>
                  <p className="text-muted">
                    {t('home.Create a password for your account')}
                  </p>
                </div>
                
                <div className="alert alert-info">
                  <strong>{t('home.Email')}:</strong> {verifiedEmail}
                </div>
                
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Label for="password">
                      {t('home.Password')} <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="password"
                      name="password"
                      id="password"
                      placeholder={t('home.Enter password (minimum 6 characters)')}
                      value={password}
                      onChange={this.handlePasswordChange}
                      className={passwordError ? 'is-invalid' : ''}
                      disabled={isSubmitting}
                    />
                    {passwordError && (
                      <div className="invalid-feedback d-block">
                        {passwordError}
                      </div>
                    )}
                  </FormGroup>
                  
                  <FormGroup>
                    <Label for="confirmPassword">
                      {t('home.Confirm Password')} <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="password"
                      name="confirmPassword"
                      id="confirmPassword"
                      placeholder={t('home.Re-enter password')}
                      value={confirmPassword}
                      onChange={this.handleConfirmPasswordChange}
                      className={confirmPasswordError ? 'is-invalid' : ''}
                      disabled={isSubmitting}
                    />
                    {confirmPasswordError && (
                      <div className="invalid-feedback d-block">
                        {confirmPasswordError}
                      </div>
                    )}
                  </FormGroup>
                  
                  <FormGroup className="mt-4">
                    <Button
                      id="btn_submit"
                      type="submit"
                      className="btn btn-brown btn-block"
                      disabled={isSubmitting}
                    >
                      {t('home.Create Account')}
                    </Button>
                    <img
                      style={{ display: 'none' }}
                      id="loader"
                      src={myConstClass.IMAGE_URL + 'loader.gif'}
                      className="img-fluid mx-auto d-block mt-2"
                      alt="Loading"
                    />
                  </FormGroup>
                </Form>
                
                <div className="text-center mt-4">
                  <p className="text-muted">
                    {t('home.Already have an account?')}{' '}
                    <Link to="/signin">{t('home.Login here')}</Link>
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  renderSuccess() {
    const { t } = this.props;
    
    return (
      <div className="container mt-5 mb-5">
        <Row className="justify-content-center">
          <Col lg="6" md="8" sm="10">
            <Card className="shadow-sm">
              <CardBody className="text-center p-5">
                <div className="mb-3">
                  <i className="fas fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
                </div>
                <h4 className="text-success">{t('home.Account Created Successfully!')}</h4>
                <p className="mt-3">
                  {t('home.Your password has been set. You can now login with your credentials.')}
                </p>
                <p className="text-muted">
                  {t('home.Redirecting to login in 2 seconds...')}
                </p>
                <div className="spinner-border text-primary mt-3" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const { pageState } = this.state;
    
    return (
      <div className="App">
        <ToastContainer enableMultiContainer containerId={'B'} />
        <Header />
        
        {pageState === 'loading' && this.renderLoading()}
        {pageState === 'error' && this.renderError()}
        {pageState === 'form' && this.renderForm()}
        {pageState === 'success' && this.renderSuccess()}
        
        <Footer />
      </div>
    );
  }
}

SetPassword.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(SetPassword);

